import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'persianToEnglishRegex',
    standalone: true
})
export class PersianToEnglishRegexPipe implements PipeTransform {
    transform(value: any): string {
        // Use regex to replace Persian numbers with English numbers
        return value.replace(/[٠-٩]/g, (d: any) => "٠١٢٣٤٥٦٧٨٩".indexOf(d)).replace(/[۰-۹]/g, (d: any) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d));
    }
}
